
import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

  @Injectable()
  export class PersonasService {
    private http:HttpClient;
    private baseUrl: string;
    constructor(_http: HttpClient, _baseUrl: string) {
      this.http = _http;
      this.baseUrl = _baseUrl;
    }
    
    public comprobar = (params:any) : Promise<any> => {
      return this.http.get(this.baseUrl + 'personas/comprobar' + params).toPromise()
        .then(result => {
          return result;
        })
        .catch(error => Promise.reject(error));
    }
    
    public post = (paramsUrl:any,params:any) : Promise<any> => {
      return this.http.post(this.baseUrl + 'personas/post' + paramsUrl, params).toPromise()
        .then(result => {
          return result;
        })
        .catch(error => Promise.reject(error));
    }
    
  }

